/**
 * User: Rob Richard
 * Date: 7/15/14
 * Time: 3:37 PM
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var TradeAssociations = module.exports = SoaCollection.extend();
var TradeAssociation = require('bunsen/models/identity/TradeAssociation');
var endpoints = require('dibs-endpoints');
var _ = require('underscore');

_.extend(TradeAssociations.prototype, {
    model: TradeAssociation,
    url: function () {
        return endpoints.tradeAssociations();
    },
    getAssociationByName: function (name) {
        return this.findWhere({ name: name });
    },
    isAssociationMember: function (name) {
        return !!this.getAssociationByName(name);
    },
    isNYDC: function () {
        return this.isAssociationMember(TradeAssociation.NAMES.NYDC);
    },
    isVerticalRestrictedAssociation: function (fn, association) {
        var seller = this.parents[0];
        if (!seller) {
            return null;
        }
        return seller[fn]() && this.isAssociationMember(association);
    },
    isAntiquesAssociationMember: function () {
        return this.isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.AADLA);
    },
    is20thCenturySpecialist: function () {
        return this.isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.TWCS);
    },
    isArtDealersAssociationMember: function () {
        return this.isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.ADAA);
    },
    isAIPADMember: function () {
        return this.isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.AIPAD);
    },
    getAntiquesAssociationLeague: function () {
        return this.filter(function (association) {
            return association.isAntiquesAssociationLeague();
        }).map(function (model) {
            return model.toJSON();
        });
    },
    save: function () {
        return this.sync('create', this, {
            url: endpoints.sellerTradeAssociations(this.parents[0].id)
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/TradeAssociations.js
// module id = 2621
// module chunks = 64